import App from 'app/app.js';
import 'app/store/LooksStore.js';
import 'app/service/RouterService.js';

function LtLookCarouselCtrl($scope, LooksStore, RouterService) {
  this.rowViews = [];

  this.pageIndex = 0;

  this.init = function () {
    var looks = LooksStore.getMruLooksOrDefault().slice();

    this.rowViews = [];

    var wrap = function (item) {
      return { look: item };
    };

    while (looks.length > 0) {
      this.rowViews.push({
        hasLooks: true,
        colViews: R.map(wrap, looks.splice(0, 3))
      });
    }

    var lastRowView = R.last(this.rowViews);

    if (!!lastRowView && lastRowView.colViews.length % 3 !== 0) {
      lastRowView.colViews.push({ look: null });
    } else {
      this.rowViews.push({ hasLooks: false });
    }
  };

  this.prevPage = function () {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  };

  this.nextPage = function () {
    if (this.pageIndex < this.rowViews.length - 1) {
      this.pageIndex++;
    }
  };

  this.selectLook = function ($event, look) {
    if ($event.target.src.indexOf(LooksStore.getPreviewImageLocation(look)) >= 0) {
      $scope.confirm({ selectedLook: look });
    }
  };

  this.goToPortraitLooks = function () {
    $scope.onGoFavoriteLooks();
    RouterService.goToPortraitLooksFromCYOP($scope.currentItemDesc, 'CYOP');
  };
}

App.controller('LtLookCarouselCtrl', ['$scope', 'LooksStore', 'RouterService', LtLookCarouselCtrl]);
